module.exports = __webpack_public_path__ + "static/media/success.e73269fe.svg";